var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullScreenDarkBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Navigation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157145",
    "data-name": "Rectangle 157145",
    width: 38,
    height: 38,
    rx: 8,
    transform: "translate(38) rotate(90)",
    fill: "#2e4d7b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157085",
    "data-name": "Rectangle 157085",
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75070",
    "data-name": "Group 75070",
    transform: "translate(-1.282 -1.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73713",
    "data-name": "Path 73713",
    d: "M4.927,9.569a.928.928,0,0,0,.928-.928V5.856H8.641A.928.928,0,1,0,8.641,4H5.392A1.346,1.346,0,0,0,4,5.392V8.641A.928.928,0,0,0,4.927,9.569Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73714",
    "data-name": "Path 73714",
    d: "M8.641,35.713H5.856V32.928a.928.928,0,1,0-1.857,0v3.249A1.346,1.346,0,0,0,5.392,37.57H8.641a.928.928,0,0,0,0-1.857Z",
    transform: "translate(0 -15.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73715",
    "data-name": "Path 73715",
    d: "M36.177,4H32.928a.928.928,0,1,0,0,1.857h2.785V8.641a.928.928,0,0,0,1.857,0V5.392A1.346,1.346,0,0,0,36.177,4Z",
    transform: "translate(-15.004 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73716",
    "data-name": "Path 73716",
    d: "M36.642,32a.928.928,0,0,0-.928.928v2.785H32.928a.928.928,0,1,0,0,1.857h3.249a1.346,1.346,0,0,0,1.392-1.392V32.928A.928.928,0,0,0,36.642,32Z",
    transform: "translate(-15.004 -15.004)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreenDarkBackground);
export default __webpack_public_path__ + "static/media/FullScreenDarkBackground.a8615438541ce3bc3b760c621b3e150b.svg";
export { ForwardRef as ReactComponent };